"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertTypeField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const hooks_1 = require("material-ui-popup-state/hooks");
const react_1 = require("react");
const type_selector_1 = require("./insert-property-field/type-selector");
const with_handler_1 = require("./with-handler");
/**
 * Our table row has to be full width to ensure its background covers the entire
 * width of the table when sticky. However, the selector should be the width
 * of the first two columns. This emulates that.
 */
const useTableColumnWidth = (tableRowRef) => {
    const [columnWidth, setColumnWidth] = (0, react_1.useState)(null);
    (0, react_1.useLayoutEffect)(() => {
        const calculateColumnWidth = () => {
            const tableRow = tableRowRef.current;
            if (!tableRow) {
                return;
            }
            let table = tableRow;
            while (table !== document.documentElement &&
                table.parentNode &&
                table.tagName !== "TABLE") {
                table = table.parentNode;
            }
            if (table.tagName !== "TABLE") {
                throw new Error("Cannot find table");
            }
            const firstHeader = table.querySelector("th:nth-of-type(1)");
            const secondHeader = table.querySelector("th:nth-of-type(2)");
            const nextColumnWidth = (firstHeader?.getBoundingClientRect().width ?? 0) +
                (secondHeader?.getBoundingClientRect().width ?? 0);
            setColumnWidth(nextColumnWidth);
        };
        calculateColumnWidth();
        window.addEventListener("resize", calculateColumnWidth);
        return () => {
            window.removeEventListener("resize", calculateColumnWidth);
        };
    }, [tableRowRef]);
    return columnWidth;
};
const InsertTypeField = ({ inputRef, onCancel, onAdd, variant, createModalPopupState, searchText, onSearchTextChange, options, }) => {
    const ourInputRef = (0, react_1.useRef)(null);
    const sharedRef = (0, material_1.useForkRef)(inputRef, ourInputRef);
    const tableRowRef = (0, react_1.useRef)(null);
    const columnWidth = useTableColumnWidth(tableRowRef);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            py: 1,
            pl: "var(--table-cell-left-padding)",
            width: `${columnWidth ?? 0}px !important`,
        }, ref: tableRowRef, children: 
        // Deferring rendering of the type selector until column width is
        // available, so the menu renders at the correct width
        columnWidth === null ? null : ((0, jsx_runtime_1.jsx)(type_selector_1.TypeSelector, { searchText: searchText, onSearchTextChange: onSearchTextChange, inputRef: sharedRef, createModalPopupState: createModalPopupState, onAdd: onAdd, onCancel: onCancel, options: options, dropdownProps: {
                query: searchText,
                createButtonProps: createModalPopupState
                    ? {
                        ...(0, with_handler_1.withHandler)((0, hooks_1.bindTrigger)(createModalPopupState), () => {
                            ourInputRef.current?.focus();
                        }),
                        onMouseDown: (evt) => {
                            evt.preventDefault();
                            evt.stopPropagation();
                        },
                    }
                    : null,
                variant: variant === "property" ? "propertyType" : "linkType",
            }, variant: variant })) }));
};
exports.InsertTypeField = InsertTypeField;
